import { EmailItem } from '../../components/List/Email/EmailList'
import { IObjectWithKey } from '@fluentui/react'
import useHost from '../useHost'
import { normalizeAxiosError, NormalizedError } from '../../reducers/errorReducer'
import { useState } from 'react'
import useEmailFilingHandler from './useEmailFilingHandler'
import { AxiosResponse } from 'axios'

export type SelectableEmail = EmailItem & IObjectWithKey

export type ProcessEmail = { id?: string; references?: string[] }

export type FilterReferences = (references: string[]) => string[]

export const PROCESS_EMAIL_TIMEOUT_LIMIT = 10000
export const PROCESS_EMAIL_TIMEOUT_LENGTH = 5000

export default function useProcessEmail() {
    const host = useHost()
    const [, setGlobalErrors] = useState<NormalizedError[]>()
    const handler = useEmailFilingHandler()

    const processEmail = (
        mailboxEmail: string,
        notificationEmail: string,
        selectedEmail: ProcessEmail,
        filterReferences: FilterReferences,
        isBatch: boolean,
    ) => {
        handler.dispatch(selectedEmail.id, {
            baseURL: process.env.INBOXER_HOST,
            url: `/api/file-message/`,
            data: {
                messageId: selectedEmail.id,
                userEmail: mailboxEmail,
                notificationEmail: notificationEmail,
                hostKey: host.RowKey,
                references: filterReferences(selectedEmail.references || []),
                isBatch: isBatch,
            },
            mapDispatchResponse: (response: AxiosResponse<void>) => response.data,
        })
    }

    const processSelection = (
        mailboxEmail: string,
        notificationEmail: string,
        messages: ProcessEmail[],
        filterReferences: FilterReferences,
        init: () => void,
        exit: () => void,
    ) => {
        init()

        return Promise.allSettled(
            messages.map(message => processEmail(mailboxEmail, notificationEmail, message, filterReferences, messages.length > 1)),
        )
            .catch(error => setGlobalErrors([normalizeAxiosError(error)]))
            .finally(() => {
                const timeout = PROCESS_EMAIL_TIMEOUT_LENGTH * messages.length
                // Short timeout to allow for Exchange to process the changes.
                setTimeout(
                    () => {
                        exit()
                    },
                    timeout < PROCESS_EMAIL_TIMEOUT_LIMIT ? timeout : PROCESS_EMAIL_TIMEOUT_LENGTH,
                )
            })
    }

    return { processSelection }
}
